<template>
    <div>
        <template v-if="!selectedItem">
            <input
            type="text"
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-gray-400 focus:border-gray-400 block w-full p-2.5"
            :class="classSrc"
            :id="labelToId"
            placeholder="Rechercher.."
            :disabled="disabled"
            v-model="searchInput"
             @input="searchInput = $event.target.value"
            >
            <ul class="mt-2 overflow-y-scroll max-h-48">
                <template v-for="(item, indexCard) in items">
                    <li @click="selectItem(item)" :test-id="'sav-select-input-item-' + indexCard" class="p-3 duration-200 border-b border-gray-200 cursor-pointer hover:bg-gray-50" :key="'sav-card-' + indexCard + '-' + Date.now()">
                        <div class="flex items-center">
                            <img v-if="item.img" class="hidden h-6 mr-3 md:block" v-lazy="imgSource(item.img)">
                            <div>
                                <div>{{item[key]}}</div>
                                <div v-if="item.moreData" class="text-xs font-light">{{item.moreData}}</div>
                            </div>
                        </div>
                    </li>
                </template>
            </ul>
            <span v-if="items && items.length == 0" class="block p-3 font-light text-gray-500">Aucun résultat</span>
        </template>
        <template v-else>
            <div class="items-center justify-between p-4 border border-gray-100 my-rounded md:flex">
                <div class="font-bold">
                    <div class="flex items-center">
                        <img v-if="selectedItem.img" class="hidden h-6 mr-2 md:block" v-lazy="imgSource(selectedItem.img)">
                        <div>
                            <div>{{selectedItem[key]}}</div>
                            <div v-if="selectedItem.moreData" class="text-xs font-light">{{selectedItem.moreData}}</div>
                        </div>
                    </div>
                </div>
                <button class="p-2 pr-3 mt-2 text-xs font-light text-white duration-200 bg-red-400 rounded cursor-pointer md:mt-0 hover:bg-red-500" @click="selectItem(null)">
                    <i class="mr-1 fas fa-times"></i> Annuler
                </button>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
        },
        classSrc: {
            type: String
        },
        disabled: {
            type: Boolean,
            default: false
        },
        options: {
            type: Object
        },
        value: {}
    },
    watch: {
        options: {
            deep: true,
            handler: function (value) {
                this.setItems()
            }
        },
        searchInput: function (value) {
            this.search(value)
        },

        value: function() {
            this.setDefaultValue()
        }
    },
    computed: {
        labelToId: function() {
            if (this.label) {
                return this.label.replace(/\s/g, '-').toLowerCase()
            }
        }
    },
    data() {
        return {
            searchInput: "",
            items: [],
            selectedItem: null,
            key: null,
        }
    },
    methods: {
        search(value) {
            this.items = []
            if (!value) {
                this.setItems()
            }

            if (value) {
                value = value.replaceAll('_', '').replaceAll(' ', '').replaceAll('-', '').replaceAll('.', '').toLowerCase()
            }
            this.options.values.forEach((option) => {
                if (!this.items.find((item) => item.id == option.id)) {
                    if (value && option[this.key]) {
                        if (option[this.key].replaceAll('_', '')
                                .replaceAll('-', '')
                                .replaceAll('.', '')
                                .toLowerCase()
                                .includes(value)
                        ) {
                            this.items.push(option)
                        }
                    }
                }
                if (!this.items.find((item) => item.id == option.id)) {
                    if (value && option.moreData) {
                        if (option.moreData) {
                            if (option.moreData.toLowerCase().includes(value)) {
                                this.items.push(option)
                            }
                        }
                    }
                }
            })
        },

        selectItem(item) {
            this.selectedItem = item
            this.searchInput = null
            this.$emit('input', item)
        },

        setItems() {
            this.items = this.options.values
            this.key = this.options.label
        },

        imgSource(item) {
            return item ? item : 'https://disticloudfiles.net/img/savinfo/default/img-broken.png'
        },

        setDefaultValue() {
            if (this.value) {
                this.selectedItem = this.value
            }
        }
    },
    mounted() {
        this.setItems()
        this.setDefaultValue()
    }
}
</script>



// WEBPACK FOOTER //
// src/components/SavSelectInput.vue